/// <reference path="../../../../app.definition.ts" />

import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { CommonService } from "@common/common.service";
import { IDocumentFolderService } from "@common/itemBoard/components/itemFolder/services/documentFolder.service";
import {
    Document,
    EventTypeEnums,
    PostTypeEnums,
} from "@common/model/_adocument";
import { Discussion } from "@common/model/discussion";
import { Subject } from "@common/model/subject";
import { User } from "@common/model/user";
import { PasswordCollectorService } from "@common/passwordCollector/services/passwordCollector.service";
import { PopUpService } from "@common/popup/popup.service";
import { CacheService } from "@common/service/cache.service";
import { ICachingService } from "@common/service/caching.service";
import { IConfigService } from "@common/service/config.service";
import { IFeedService } from "@common/service/feed.service";
import { TeamVaultService } from "@common/service/teamvault.service";
import { IUserService } from "@common/service/user.service";
import angular from "angular";
import { PushNotificationService } from "@common/service/push-notification.service";
import { ScriptService } from "@common/service/script.service";
import { DiscussionComment } from "@common/model/discussionComment";
import _ from "lodash";
import { Util } from "@common/util";
import { FOLDER_MODULES, convertibleTypes, MENU_ACTIONS, SIGNATURE_FLOW, SIGNATURE_FLOW_UNITS } from "@common/model/constants";
import { IPdfViewerService } from "@/app/library/PdfViewer/service/pdfViewer.service";
import { IAppRootScopeService } from "@/app/app.definition";
import { UtilityService } from "@common/service/util.service";
import { IDocumentService } from "@common/service/document.service";
import { BroadcastService } from "@common/service/broadcast.service";
import { WebSocketService } from "@common/service/web-socket.service";
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import 'videojs-youtube/dist/Youtube.min.js';
import { IConditionalModuleLoadService } from '@/app/common/service/conditionalModuleLoad.service';


export interface IEcvPost {
    post: Discussion;
    showShareControls: boolean;
    isSharedView: boolean;
    init($el?: ng.IAugmentedJQuery): void;
    initialized: boolean;
    hasDiscussion(): boolean;
    hasDocument(): boolean;
    hasImage(): boolean;
    toggleExpandedCard($event): void;
    downloadDocument($event): void;
    getPost(): Discussion;
    getFilename(): string;
    itemActionCallback(action: string, itemType: string, itemId: any): void;
    downloadSharedDocument($event): void;
    navigateToOrganize(): void;
    loadMoreComments(
        then?: Function,
        fetchSystemComments?: any
    ): ng.IPromise<any>;
}

export class PostType {
    file: boolean;
    photo: boolean;
    base: string;

    constructor(obj: any) {
        this.file = obj.file;
        this.photo = obj.photo;
        this.base = obj.base;
    }
}

export class EcvPost implements IEcvPost {
    DocumentUsers: any;
    registeredVm: boolean;
    post: Discussion;
    postModelled: Discussion;
    document: Document;
    user: User;
    displayAs: string;
    showComments: boolean;
    expandOnClick: boolean;
    commentCallback: Function;
    title: string;
    desc: string;
    dispMax: number;
    titleDispMax: number;
    subjectAge: number;
    scrollHeight: number;
    expandedCard: boolean;
    firstExpand: boolean;
    postType: PostType;
    ovarMax: boolean;
    attachment: {
        title: String;
        file: String;
        type: String;
        extension: String;
        postType: String;
    };
    content: String;
    shortContent: string;
    subject: Subject;
    overMax: boolean;
    postCallback: Function;
    comment: { text: string };
    isCommentBlank: boolean;
    // Confirmation message shown by ecv-confirm-tooltip on the comment delete icon.
    deleteCommentMsg: string =
        "Delete this comment? This can't be undone. Click delete again to confirm.";
    $el: ng.IAugmentedJQuery;
    errImg: string;
    defaultMugshot: string;
    defaultExpanded: boolean;
    showShareControls: boolean;
    enableCrProfile: boolean;
    titleEditMode: boolean;
    descEditMode: boolean;
    originalTitle: string;
    originalDesc: string;
    isSharedView: boolean;
    initialized: boolean;
    showEditor: boolean;
    forceHideView: boolean | string;
    signAssignor: any;
    signatureEvent: any;
    currentUserId: any;
    showDocESignSection: boolean;
    listView: boolean;
    currentUser: any;
    hasSignPermission: boolean;
    selectedDocs: any;
    multiSelectMode: boolean;
    isEnterpriseDoc: boolean;
    postTypeEnums;
    isLink: boolean;
    allowShare: boolean;
    originalSummary: string;
    isRegeneratedSummaryAvailable: boolean;
    regeneratedSummary: string;
    regeneratedSummaryId: string;
    showGenerated: boolean;
    copyTooltipText: string;
    replaceTooltipText: string;
    copyTooltip: any;
    rgsstatus: any;
    cmenuPlacement: string;
    isTitleSaving: boolean;
    SIGNATURE_FLOW;
    SIGNATURE_FLOW_UNITS;
    showSignatureBadge: boolean = false;
    signatureStatus: any;
    signatureTableParams: any;
    static $inject = [
        "$rootScope",
        "$scope",
        "$state",
        "$timeout",
        "$http",
        "ConfigService",
        "UserService",
        "CommonService",
        "ApiAdapterService",
        "CacheService",
        "PasswordCollectorService",
        "PopUpService",
        "TeamVaultService",
        "PdfViewerService",
        "$q",
        "CachingService",
        "$uibModal",
        "DocumentService",
        "$sce",
        "UtilityService",
        "ConditionalModuleLoadService",
        "FeedService",
        "DocumentFolderService",
        "BroadcastService",
        "PushNotificationService",
        "WebSocketService",
        "storageConfig",
        "ScriptService",
        "ecareEnv",
        "$ocLazyLoad",
        "NgTableParams",
    ];
    constructor(
        private $rootScope: IAppRootScopeService,
        private $scope: angular.IScope,
        private $state: angular.ui.IStateService,
        private $timeout: angular.ITimeoutService,
        private $http: any,
        private $_config: IConfigService,
        private $_user: IUserService,
        private $_com: CommonService,
        private $_api: JavaApiAdapterService,
        private $_cache: CacheService,
        private $_pass: PasswordCollectorService,
        private $_pop: PopUpService,
        private $_team: TeamVaultService,
        private $_pdfViewerSvc: IPdfViewerService,
        private $q: angular.IQService,
        private $_caching: ICachingService,
        private $uibModal: angular.ui.bootstrap.IModalService,
        private $_document: IDocumentService,
        private $sce: angular.ISCEService,
        private UtilityService: UtilityService,
        private conditionalModuleLoadService: IConditionalModuleLoadService,
        private $_feed: IFeedService,
        private $_docFolder: IDocumentFolderService,
        private BroadcastService: BroadcastService,
        private $_pushNotificationService: PushNotificationService,
        private WebSocketService: WebSocketService,
        private storageConfig: any,
        private $_ScriptService: ScriptService,
        private ecareEnv: string,
        private $ocLazyLoad: any,
        private NgTableParams: any
    ) {
        this.initialized = false;
        this.SIGNATURE_FLOW = SIGNATURE_FLOW;
        this.SIGNATURE_FLOW_UNITS = SIGNATURE_FLOW_UNITS;
        this.showDocESignSection = false;
        this.currentUser = this.$_cache.getUser();
        this.hasSignPermission =
            !!this.$_cache.getFeatures() &&
            this.$_cache.getFeatures().signature;
        this.postTypeEnums = PostTypeEnums;
        this.isRegeneratedSummaryAvailable = false;
        this.signatureStatus = null;
       this.$rootScope.mainShowLoader = false;
        this.BroadcastService.registerCallBack(
            "password-taken",
            $scope.$id,
            () => {
                !this.initialized && this.init(this.$el || null);
            }
        );


        // Listen for signature completion events to refresh signature status
        this.BroadcastService.registerCallBack(
            "update-document-signature-status",
            $scope.$id,
            (documentId) => {
                if (this.post && this.post.id == documentId && this.expandedCard) {
                    this.loadSignatureStatus();
                }
            }
        );

        if (this.$state.params.regeneratedSummary != null) {
            this.$rootScope.mainShowLoader = true;
            this.$_api.fetchAISummary(this.$state.params.documentId).then(
                (s) => {
                    this.originalSummary = s.summary || "";
                    this.$rootScope.mainShowLoader = false;
                    this.isRegeneratedSummaryAvailable = true;
                    this.regeneratedSummaryId =
                        this.$state.params.regeneratedSummary.documentSummaryId;
                    this.regeneratedSummary =
                        this.$state.params.regeneratedSummary.newSummary;
                    // automatically set focus to the regenerated summary box
                    setTimeout(function () {
                        document
                            .getElementById("regenerated-summary")
                            .scrollIntoView();
                    }, 200);
                    this.$state.params.regeneratedSummary = null;
                    return;
                },
                (e) => {
                    this.$state.params.regeneratedSummary = null;
                    this.$rootScope.mainShowLoader = false;
                    if (!!e) {
                        toastr.error(e);
                    } else {
                        toastr.error(
                            "Something went wrong. Please try after some time."
                        );
                    }
                }
            );
        }

        $scope.$on("$destroy", function () {
            BroadcastService.removeCallBack("password-taken", $scope.$id);
            BroadcastService.removeCallBack("update-document-signature-status", $scope.$id);
        });
    }

    itemActionCallback = (
        action: string,
        itemType: string,
        itemId: any
    ): void => {
        if (
            action.toUpperCase() == "DELETE" &&
            (itemType == "FOLIO" || itemType == "DOCUMENT")
        ) {
            //this.$el.remove();
            // let $els = this.$el.parent().find(".post-container");
            // if ($els.length == 0) {
            this.postCallback(this, action.toUpperCase());
            // }
        }
    };

    handleDocumentNavigation = (isLink: boolean) => {
        if (isLink) {
            this.$state.go('documents-load', { action: 'view-document', stateParams: { documentId: this.post.id, postType: this.postTypeEnums.LINK } });
        } else {
            this.$state.go('documents-load', { action: 'view-document', stateParams: { documentId: this.post.id } });
        }
    }

    editorCreated = (editor) => {
        this.UtilityService.setURLPlaceholder(editor);
    };

    contentChanged(editor: any, html: any, text: string, content: any): void {
        if (text.trim() == "") {
            this.isCommentBlank = true;
        } else {
            this.isCommentBlank = false;
        }
    }

    isLinkActive(signStatus: number, factor: any): boolean {
        let result = signStatus & factor;
        return result == factor;
    }
    isDocOwner(): boolean {
        let isDocOwner = false;
        if (!!this.currentUser) {
            let currentUserId = this.currentUser.id;
            isDocOwner =
                this.hasSignPermission &&
                (this.isEnterpriseDoc || currentUserId == this.post.ownerId);
        }
        return isDocOwner;
    }

    /**
     * Check if the "Sign the Document" link should be shown
     * Only show if:
     * - Subject exists and is not frozen or former team member
     * - Document is a PDF
     * - Document is in pending state (signStatus & 16 === 16)
     */
    shouldShowSignDocumentLink(): boolean {
        return !!this.post.subject &&
               !this.post.subject.isFrozen &&
               !this.post.subject.isFormerTeamMember &&
               this.isPDF() &&
               this.isLinkActive(this.post.signStatus, SIGNATURE_FLOW_UNITS.ASSIGNED_TO_SIGN);
    }

    isDocSignSectionActive(view): boolean {
        if (this.isPDF()) {
            let setupOrApply =
                !!this.post.subject &&
                !this.post.subject.isFrozen &&
                !this.post.subject.isFormerTeamMember &&
                this.isDocOwner() &&
                (this.isLinkActive(
                    this.post.signStatus,
                    SIGNATURE_FLOW_UNITS.SETUP_SIGN
                ) ||
                    this.isLinkActive(
                        this.post.signStatus,
                        SIGNATURE_FLOW_UNITS.APPLY_TEMPLATE
                    ));
            let review =
                this.isDocOwner() &&
                this.isLinkActive(
                    this.post.signStatus,
                    SIGNATURE_FLOW_UNITS.REVIEW
                );

            let signDocument = this.shouldShowSignDocumentLink();
            let downloadSignDoc = this.showDownloadSignedLink();
            if (!view) {
                return (
                    setupOrApply || review || signDocument || downloadSignDoc
                );
            } else {
                return downloadSignDoc;
            }
        } else {
            return false;
        }
    }

    static hasImage(post: Discussion): boolean {
        if (post.keywords) {
            if (post.keywords.indexOf("image") == 0) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    static isDiscussion(post: Discussion): boolean {
        return !!post.contentType && post.contentType == "discussion";
    }

    static hasComments(post: Discussion): boolean {
        return !!post.comments && post.comments.length > 0;
    }

    static hasFile(post: Discussion): boolean {
        return (
            !EcvPost.hasImage(post) &&
            !!post.filename &&
            post.filename != "" &&
            post.keywords != "status"
        );
    }

    private static postTypes = {
        note: new PostType({
            file: false,
            photo: false,
            base: "note",
        }),
        "photo-note": new PostType({
            file: false,
            photo: true,
            base: "note",
        }),
        document: new PostType({
            file: true,
            photo: false,
            base: "document",
        }),
        "document-photo": new PostType({
            file: true,
            photo: true,
            base: "document",
        }),
        discussion: new PostType({
            file: false,
            photo: false,
            base: "discussion",
        }),
        "discussion-document": new PostType({
            file: true,
            photo: false,
            base: "discussion",
        }),
        "discussion-photo": new PostType({
            file: true,
            photo: true,
            base: "discussion",
        }),
    };

    private static getPostType(post: Discussion): PostType {
        let hasImage: boolean = EcvPost.hasImage(post);
        let isDiscussion: boolean = EcvPost.isDiscussion(post);
        let hasComments: boolean = EcvPost.hasComments(post);
        let hasFile: boolean = EcvPost.hasFile(post);

        if (post.documentType == "FOLIO") {
            return EcvPost.postTypes[
                hasImage ? "photo-note" : hasComments ? "discussion" : "note"
            ];
        }

        if (post.documentType == "DOCUMENT") {
            return EcvPost.postTypes[
                hasComments
                    ? hasImage
                        ? "discussion-photo"
                        : hasFile
                            ? "discussion-document"
                            : "discussion"
                    : hasImage
                        ? "document-photo"
                        : "document"
            ];
        }

        return null;
    }

    updateNotiDot = () => {
        this.post.hasNotificationUpdate = false;
        this.BroadcastService.broadcast("update-notification-array", [
            this.post.id,
        ]);
        if (!this.post.viewed) {
            this.$_document.updateEntityViewed(
                this.post.postType,
                this.post.id
            );
        }
    };

    toggleExpandedCard($event): void {
        //To handle dblclick
        if ($event.originalEvent.detail == 1) {
            this.updateNotiDot();
        }
        if (!!this.multiSelectMode) {
            this.toggleDocSelection();
            return;
        }
    }

    getPost(): Discussion {
        return this.post;
    }

    private getFileExtension(filename: string) {
        if (!!filename) {
            return filename
                .substring(filename.lastIndexOf(".") + 1)
                .toLowerCase();
        }
        return null;
    }

    failedToLoad: [number];

    loadMoreComments = (then?: Function, fetchSystemComments?: any) => {
        let deferred = this.$q.defer();
        let loadSystemMessage = false;
        if (this.displayAs == "discussion") {
            loadSystemMessage = true;
        }

        this.post.commentLoader = true;
        this.$_team
            .getComments(
                this.post.discussionId,
                this.$_cache.getPassword(),
                loadSystemMessage
            )
            .then(
                (s: Array<DiscussionComment>) => {
                    if (s != null && s.length > 0) {
                        this.post.comments = s;
                        this.post.commentsCount = s.length;
                    }

                    this.post.commentLoader = false;
                    if (!!then) {
                        then(s);
                    }

                    deferred.resolve("success");
                },
                (e) => {
                    console.error(
                        "EcvPost: Error loading comments for post:",
                        this.post.discussionId
                    );
                    deferred.reject("error");
                }
            );

        return deferred.promise;
    };

    init($el?: ng.IAugmentedJQuery): void {
        !!$el && (this.$el = $el);
        this.signatureEvent = this.$state.params.signatureEvent
        if (
            (!!this.post && !!this.$_cache.getPassword()) ||
            !!this.isSharedView
        ) {
            this.postType = EcvPost.getPostType(this.post);
            if (this.postType != null) {
                if (!this.registeredVm && this.registeredVm) {
                    this.registeredVm = true;
                    this.postCallback(this);
                }
                this.postModelled = new Discussion().deserialize(this.post); //Guarantee we have a Discussion
                this.firstExpand = true;
                this.attachment = null;
                this.expandedCard = this.defaultExpanded == true ? true : false;
                this.titleEditMode = false;
                this.descEditMode = false;
                this.isEnterpriseDoc =
                    !this.isSharedView &&
                    _.includes(
                        [PostTypeEnums.LINK, PostTypeEnums.DOCUMENT],
                        this.post.postType
                    ) &&
                    this.currentUser.organizationId > 0 &&
                    this.currentUser.organizationId ==
                    this.post.owner.organizationId;
                this.isLink = this.post.postType == PostTypeEnums.LINK;
                this.allowShare =
                    this.post.subjectId ||
                    Util.safeAccess(this.post.userPerm, ["share"]); // For RL docs show share icon only if share permission is available
                if (!!this.selectedDocs) {
                    let thisPostId = this.post.id;
                    let ind = this.selectedDocs.findIndex(
                        (p) => p.id == thisPostId
                    );
                    if (ind != -1) {
                        this.post.isSelected = true;
                    }
                }

                this.forceHideView == true ||
                    (this.forceHideView == "true" &&
                        (this.forceHideView = true)) ||
                    (this.forceHideView = false);

                this.dispMax = this.$_config.get("postCharDispMax");
                this.titleDispMax = this.$_config.get("postTitleDispMax");

                this.user = this.$_user.getMe();
                this.title =
                    this.post.title ||
                    this.post.displayData ||
                    this.post.comment ||
                    this.getFilename() ||
                    null;
                if (!!this.title) {
                    if (!!this.post.additionalProperties) {
                        this.originalTitle =
                            "Title changed to " +
                            this.post.additionalProperties.additionalProperties
                                .NEWTITLE +
                            " from " +
                            this.post.additionalProperties.additionalProperties
                                .OLDTITLE;
                    } else {
                        this.originalTitle = this.title;
                    }
                } else {
                    this.originalTitle = this.title = "Untitled Note";
                }
                if (this.isLink) {
                    this.attachment = {
                        title: null,
                        file: null,
                        extension: null,
                        type: null,
                        postType: this.post.postType,
                    };
                } else if (this.postType.file || this.postType.photo) {
                    this.attachment = {
                        title:
                            this.postType.file && !!this.post.name
                                ? this.post.name
                                : this.getFilename(),
                        file: this.getFilename(),
                        extension: this.getFileExtension(this.getFilename()),
                        type: this.postType.photo ? "image" : "document",
                        postType: null,
                    };
                } else {
                    this.attachment = null;
                }

                this.content =
                    this.post.comment || this.post.displayData || null;

                // if (!this.content && this.postType.file && this.post.comments.length > 0) {
                //     this.content = this.post.comments[0].comment;
                // }

                !this.content && (this.content = ""); //'[No Message]');

                this.overMax =
                    !!this.content && this.content.length > this.dispMax;
                this.overMax &&
                    (this.shortContent = this.content.substring(
                        0,
                        this.dispMax
                    ));

                !!this.showComments || (this.showComments = false);

                this.document = null;
                this.desc = !!this.post.comment ? this.post.comment : null;
                this.originalDesc = !!this.desc ? this.desc : null;
            }
            this.errImg = this.$_config.get("defaultThumbnail", "");
            this.defaultMugshot = this.$_config.get("defaultMugshot", "");

            if (!!this.post.comments) {
                for (let c = 0; c < this.post.comments.length; c++) {
                    this.post.comments[c].sender.photo =
                        this.post.comments[c].senderPhoto;
                }
            }

            if (!!this.showShareControls) {
                // do something
            } else {
                this.showShareControls = true;
            }

            if (!!this.enableCrProfile) {
                // do something
            } else {
                this.enableCrProfile = true;
            }

            if (!!this.isSharedView) {
                // do something
            } else {
                this.isSharedView = false;
            }

            // Update badge visibility - status computation is handled inside the badge directive
            this.updateSignatureBadgeVisibility();

            this.initialized = true;

            // Load signature status in the background (non-blocking)
            if (this.displayAs === 'document' && this.expandedCard) {
                this.$timeout(() => {
                    this.loadSignatureStatus();
                }, 100);
            }
        } else {
            // console.log("No vk, waiting until notified");
        }
        if (!this.cmenuPlacement) {
            this.cmenuPlacement = "";
        }
        if (this.signAssignor) {
            this.conditionalModuleLoadService.getSignatureService().then((service) => {
                if (
                    !!this.post.subject &&
                    !this.post.subject.isFrozen &&
                    !this.post.subject.isFormerTeamMember
                ) {
                    if (this.signAssignor == this.currentUser.userId && this.signatureEvent == 'SIGNED') {
                        this.showSignaturePopUp(undefined, false);
                    } else {
                        service.signTheDocument(this.post);
                    }
                } else {
                    this.$state.go('documents-load', {
                        stateParams: {
                            documentId: this.post.id,
                            assignor: undefined,
                        },
                        action: 'view-document'
                    }, { reload: true });
                }
            });
        }
        this.copyTooltipText = "Copy to clipboard";
        this.replaceTooltipText =
            "Would you like to replace the existing summary with this new AI-generated summary? Click again to continue.";
        this.copyTooltip = angular.copy(this.copyTooltipText);
    }


    getOrder = () => {
        return this.selectedDocs.findIndex((p) => p.id == this.post.id) + 1;
    };

    /**
     * Update signature badge visibility to prevent flickering
     * Checks all conditions needed to show the badge.
     * The actual PENDING/SIGNED status computation is handled inside the badge directive.
     */
    updateSignatureBadgeVisibility = () => {
        this.showSignatureBadge =
            this.post.signStatus !== null &&
            this.post.signStatus !== undefined &&
            !this.titleEditMode &&
            (this.displayAs === 'document'  || this.displayAs === 'note') &&
            !this.isSharedView;
    };


    showSignaturePopUp($event, flow): ng.IPromise<any> {
        this.updateNotiDot();
        if ($event) {
            this.doNothing($event);
        }
        let deferred = this.$q.defer();

        if (this.post.rawDocSize > Util.DOCSIZE_THRESOLD) {
            toastr.error(Util.SIGNATURE_NOT_ALLOWED_LG_DOC);
            deferred.reject(Util.SIGNATURE_NOT_ALLOWED_LG_DOC);
        } else {
            this.$rootScope.mainShowLoader =
                "Please wait while we fetch your document...";
            this.conditionalModuleLoadService.getSignatureService().then((service) => {
                service.openSignaturePopup(this.post, flow, this.signAssignor);
            });
        }
        return deferred.promise;
    }
    showActualSigningPopup($event): void {
        this.updateNotiDot();
        this.doNothing($event);
        this.conditionalModuleLoadService.getSignatureService().then((service) => {
            service.signTheDocument(this.post);
        });
    }

    private doDownload(): void {
        this.$_com.downloadDocument(
            this.UtilityService.getTitleWthExt(this.post),
            this.document.keywords,
            this.document.content
        );
    }

    private doSharedDownload(keywords: any, content: any): void {
        this.$_com.downloadDocument(
            this.UtilityService.getTitleWthExt(this.post),
            keywords,
            content,
            false
        );
    }

    doPresignedUrlDownload(docDetailObj: any): void {
        let context = this;
        let doc = this.getDocDownloadObj(false);
        if (doc.rawDocSize > Util.DOCSIZE_THRESOLD) {
            let src =
                this.storageConfig.url +
                "/" +
                (this.ecareEnv != "my" ? "dev-" : "") +
                "shared-doc-downloads-ecarevault-com";
            context.$_com.downloadViaBrowser(
                docDetailObj.presignedUrl,
                doc.filename,
                src
            );
            this.$rootScope.mainShowLoader = false;
        } else {
            this.$http({
                method: "GET",
                url: docDetailObj.presignedUrl,
                responseType: "arraybuffer",
            })
                .then(
                    (response, status, headers) => {
                        let keywords = docDetailObj["keywords"];
                        let content = response["data"];
                        context.doSharedDownload(keywords, content);
                    },
                    (response) => {
                        console.log("Fetch Error :-S", response);
                    }
                )
                .finally(() => {
                    this.$rootScope.mainShowLoader = false;
                });
        }
    }

    viewDocument($event): void {
        this.updateNotiDot();
        this.doNothing($event);
        if (this.post.rawDocSize > Util.DOCSIZE_THRESOLD) {
            toastr.error(Util.VIEW_IN_BROWSER_NOT_ALLOWED_LG_DOC);
        } else {
            if (!this.document || !this.document.content) {
                let post = {
                    documentId: this.post.id,
                    isConvertedPdf: true,
                    downloadSignedCopy: false,
                    permissionType: this.post.permissionType,
                    filename: this.post.filename,
                    title: this.post.title,
                    keywords: this.post.keywords,
                };
                this.$_document.getDocumentLink(post);
            } else {
                this.doDownload();
            }
        }
    }

    viewLink(): void {
        if (this.isSharedView) {
            window.open(this.post.url, "_blank");
        } else {
            this.updateNotiDot();
            this.$rootScope.mainShowLoader = true;
            this.$_api.checkMonetizedLink(this.post.url).then((data) => {
                if (data === true) {
                    this.$rootScope.mainShowLoader = false;
                    window.open(this.post.url, "_blank");
                } else {
                    this.$rootScope.showVideo = true;
                    this.$rootScope.mainShowLoader = false;
                    let lastPausedTime = 0;
                    setTimeout(() => {
                        let endScreen =
                            document.getElementById("custom-end-screen");
                        let player = videojs("my_video_1", {
                            techOrder: ["youtube"],
                            sources: [
                                {
                                    type: "video/youtube",
                                    src: this.post.url,
                                },
                            ]
                        });
                        const closeBtn =
                            document.getElementById("closeBtn");
                        player.on("pause", () => {
                            lastPausedTime = player.currentTime();
                            this.exitFullScreen();
                            player.hide();
                            this.handleEndScreen(
                                "fa fa-play-circle ",
                                "Click to play the video!"
                            );
                        });
                        player.on("error", () => {
                            this.handleEndScreen(
                                "fa fa-exclamation-circle",
                                "Video is not available!"
                            );
                        });
                        player.on("ended", () => {
                            this.exitFullScreen();
                            player.hide();
                            this.handleEndScreen(
                                "fa fa-undo",
                                "Click to restart the video!"
                            );
                        });
                        endScreen.addEventListener("click", () => {
                            if (!player.error()) {
                                endScreen.style.display = "none";
                                player.show();
                                player.currentTime(lastPausedTime);
                                player.play();
                            }
                        });
                        closeBtn.addEventListener("click", () => {
                            player.dispose();
                            this.$rootScope.showVideo = false;
                        });
                    }, 50);
                }
            });
            this.$_api.viewLink({
                id: this.post.id,
                eventType: EventTypeEnums.VIEW_IN_BROWSER,
                documentFolderId: this.post.documentFolderId,
                userId: this.currentUser.userId,
            });
        }
    }

    exitFullScreen() {
        let document: WindowDocument = window.document;
        if (document.fullscreenElement != null) {
            // Check if in fullscreen
            if (document.exitFullscreen) {
                document.exitFullscreen(); // Standard way to exit fullscreen
            } else if (document.webkitExitFullscreen) {
                // Safari/Chrome
                document.webkitExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                // Firefox
                document.mozCancelFullScreen();
            } else if (document.msExitFullscreen) {
                // IE/Edge
                document.msExitFullscreen();
            }
        }
    }

    handleEndScreen(iconClass, text) {
        let endScreen = document.getElementById("custom-end-screen");
        let vIcon = document.getElementById("vIcon");
        let vPara = document.getElementById("vpara");
        endScreen.style.display = "flex";
        vIcon.className = iconClass;
        vPara.textContent = text;
    }
    downloadDocument(
        $event,
        type?: string,
        downloadSignedCopy?: boolean
    ): void {
        this.updateNotiDot();
        this.doNothing($event);
        if (isIE11 && this.post.rawDocSize > Util.DOCSIZE_THRESOLD) {
            toastr.error(Util.IE_DOWNLOAD_NOT_ALLOWED_LG_DOC);
        } else {
            if (!this.document || !this.document.content) {
                let obj = this.getDocDownloadObj(downloadSignedCopy);
                this.WebSocketService.downloadMultiDoc([obj], null);
            } else {
                this.doDownload();
            }
        }
    }

    downloadSharedDocument($event): void {
        this.updateNotiDot();
        this.doNothing($event);
        this.$rootScope.mainShowLoader = true;
        this.$_api.downloadSharedDocument(this.post.code).then(
            (s) => {
                this.doPresignedUrlDownload(s);
            },
            (e) => {
                this.$rootScope.mainShowLoader = false;
                if (!!e) {
                    toastr.error(e);
                } else {
                    toastr.error(
                        "Something went wrong. Please try after some time."
                    );
                }
            }
        );
    }

    isPDF = () => {
        return (
            this.post.filename != null &&
            this.getFileExtension(this.post.filename).toLocaleLowerCase() ==
            "pdf"
        );
    };
    doNothing($event): void {
        $event.preventDefault();
        $event.stopPropagation();
    }

    private openPassword(): void {
        let that = this;
        this.$_pass.openPasswordModal().then((success) => {
            let passwordCollected = success.value;
            that.$_cache.setPassword(passwordCollected);
            that.init();
        });
    }

    private isImage(post: Discussion): boolean {
        let filename = this.getFilename();
        let extension: string = filename.substring(
            filename.lastIndexOf(".") + 1
        );
        let fromKeyword: boolean =
            this.postType.base != "note" &&
            ("image/png" == post.keywords || "image/jpeg" == post.keywords);
        let fromFilename: boolean =
            this.postType.base != "note" &&
            (extension == "jpg" || extension == "jpeg" || extension == "png");
        return fromKeyword || fromFilename;
    }

    hasDiscussion(): boolean {
        return (
            !!this.post && !!this.post.comments && !!this.post.comments.length
        );
    }

    hasDocument(): boolean {
        return (
            !!this.post &&
            ((!!this.post.filename &&
                this.post.filename != "" &&
                this.post.keywords != "status" &&
                this.post.documentType == "DOCUMENT") ||
                !!this.post.thumbnail ||
                (!!this.post.attachments &&
                    !!this.post.attachments[0] &&
                    !!this.post.attachments[0].filename))
        );
    }

    getFilename(): string {
        if (!!this.post) {
            if (
                !!this.post.attachments &&
                !!this.post.attachments[0] &&
                !!this.post.attachments[0].filename
            ) {
                return this.post.attachments[0].filename;
            }

            if (!!this.post.filename && this.post.filename != "") {
                return this.post.filename;
            }
        }
        return null;
    }

    hasImage(): boolean {
        return (
            !!this.post &&
            (!!this.post.thumbnail ||
                (!!this.post.attachments[0] &&
                    !!this.post.attachments[0].thumbnail))
        );
    }

    subjectPhoto(): string {
        return (
            (!!this.subject && this.subject.photo) ||
            this.$_config.get("defaultMugshot", "")
        );
    }

    //Toggle the comment input box and the editor for posting comments
    toggleCommentBox(showEditor: boolean, $event?): void {
        let that = this;
        if (!!$event) {
            $event.preventDefault();
            $event.stopPropagation();
        }

        let editor = document.getElementById("comment-editor-" + this.post.id);
        let commentBox = document.getElementById("comment-box-" + this.post.id);

        // Only one editor open at a time: opening the new-comment box closes any
        // comment that is currently being edited.
        if (showEditor) {
            this.closeCommentEdits();
        }

        this.showEditor = showEditor;
        if (showEditor) {
            that.$timeout(function () {
                (that.$el.find("div.ql-editor")[0] as HTMLElement).focus();
            }, 100);
        }
    }

    // Close every comment that is open in edit mode (optionally keeping one).
    // Unsaved text is discarded, same as pressing Cancel.
    private closeCommentEdits(except?: any): void {
        let comments = !!this.post ? this.post.comments : null;
        for (let i = 0; !!comments && i < comments.length; i++) {
            if (comments[i] !== except && !!comments[i].editMode) {
                this.cancelCommentEdit(comments[i]);
            }
        }
    }

    // Close the new-comment composer (clears the draft so the editor actually hides —
    // the template keeps it visible while comment.text is non-empty).
    private closeCommentComposer(): void {
        if (!!this.comment) {
            this.comment.text = "";
        }
        this.isCommentBlank = false;
        this.showEditor = false;
    }

    cancel($event): void {
        if (!!this.comment) this.comment.text = "";
        this.toggleCommentBox(false, $event);
    }

    private commentCallbackFn = () => {
        this.comment.text = "";
        this.post.commentLoader = false;
        this.$timeout(this.scrollDiscussionDown, 150);
    };

    sendComment($event): void {
        this.$rootScope.mainShowLoader = "Sending...";
        $event.preventDefault();
        $event.stopPropagation();
        this.post.commentLoader = true;
        //console.debug('EcvPost: Discussion: Send button clicked, Calling comment callback.', this.comment);
        this.post.currentComment = this.comment.text;
        //this.post.currentComment.commentType = 'USER_DEFINED';
        this.commentCallback(this.post, this.commentCallbackFn);
        this.comment.text = "";
        this.toggleCommentBox(false);
    }

    // ===== Edit / delete of the current user's own comments =====

    // Edit + delete controls are shown only on the author's own, persisted,
    // non-deleted USER_DEFINED comments (system entries are excluded).
    canModifyComment(message: any): boolean {
        return (
            !!message &&
            !!this.user &&
            message.senderId == this.user.userId &&
            (message.commentType == "USER_DEFINED" || !message.commentType) &&
            !message.deleted &&
            !!message.id &&
            message.id != 999999
        );
    }

    // Enter in-place edit: stash the original (for Cancel) and pre-populate the editor.
    toggleCommentEdit(message: any, state: boolean): void {
        if (state) {
            // Only one editor open at a time: close any other comment being edited
            // and the new-comment composer.
            this.closeCommentEdits(message);
            this.closeCommentComposer();
            message._originalComment = message.comment;
            message.editText = message.comment;
            message._editBlank = false;
            message._editDisabled = true; // Save stays disabled until a real change
            message._baselineSig = null;  // captured once Quill renders the original
            message.delFlag = false;      // disarm any pending delete confirmation
        }
        message.editMode = state;
        if (state) {
            this.$timeout(() => {
                let el = this.$el.find(
                    "#comment-edit-" + message.id + " div.ql-editor"
                )[0] as HTMLElement;
                !!el && el.focus();
            }, 150);
        }
    }

    // Reuse the composer's editor-created hook (URL placeholder), then capture the
    // baseline signature of the ORIGINAL content once Quill has rendered it (post-$render),
    // so Save can enable only on a genuine content/formatting change.
    commentEditorCreated(message: any, editor: any): void {
        this.editorCreated(editor);
        this.$timeout(() => {
            message._baselineSig = this.normalizeCommentSig(editor.root.innerHTML);
        }, 0);
    }

    // Normalized signature of comment HTML: keeps formatting tags (so bold/italic/lists
    // count as a change) but ignores whitespace-only differences.
    private normalizeCommentSig(html: string): string {
        let s = html || "";
        s = s.replace(/&nbsp;/gi, " ").replace(/ /g, " ");
        s = s.replace(/<p>(?:\s|<br\s*\/?>)*<\/p>/gi, ""); // empty lines
        s = s.replace(/>\s+</g, "><"); // whitespace between tags
        s = s.replace(/\s+/g, " ").trim(); // collapse runs
        return s;
    }

    // Enable Save only when the content/formatting actually differs from the original
    // (whitespace-only edits and reverts keep it disabled). Blank always disables.
    commentEditChanged(message: any, html: string, text: string): void {
        let blank = !text || text.trim() == "";
        message._editBlank = blank;
        // Baseline not captured yet (editor still loading the original) → keep disabled.
        if (message._baselineSig == null) {
            message._editDisabled = true;
            return;
        }
        message._editDisabled =
            blank || this.normalizeCommentSig(html) === message._baselineSig;
    }

    // Cancel edit: restore the original text and close the editor (mirrors resetFieldText).
    cancelCommentEdit(message: any): void {
        message.comment = message._originalComment;
        message.editText = message._originalComment;
        message.editMode = false;
        message._editBlank = false;
    }

    // Save edit: sanitise like PostService.addComment, block empty (use Delete instead),
    // no-op when unchanged, otherwise PUT and mark the comment as edited.
    saveCommentEdit(message: any): void {
        let filtered = (message.editText || "").replace(/[&]nbsp[;]/gi, "");
        filtered = filtered.replace(/\s\s+/g, " ");
        filtered = filtered.replace(/[<]br[^>]*[>]/gi, "");
        filtered = filtered.trim();

        if (!filtered || filtered.length == 0) {
            this.$_pop.openInformationModal(
                "A comment can't be empty. Use Delete to remove it instead."
            );
            return;
        }

        if (filtered == (message._originalComment || "").trim()) {
            message.editMode = false;
            return;
        }

        this.$rootScope.mainShowLoader = "Saving...";
        this.$_api
            .updateDiscussionComment(
                filtered,
                this.$_cache.getPassword(),
                this.post.id,
                message.id
            )
            .then(
                (updated) => {
                    message.comment =
                        !!updated && !!updated.comment ? updated.comment : filtered;
                    message.isEdited =
                        !!updated && updated.isEdited != null ? updated.isEdited : true;
                    message.editedTime =
                        !!updated && !!updated.editedTime
                            ? updated.editedTime
                            : new Date().getTime();
                    message.editMode = false;
                    this.$rootScope.mainShowLoader = false;
                    toastr.success("Comment updated.", "");
                },
                (e) => {
                    this.$rootScope.mainShowLoader = false;
                    this.$_pop.openInformationModal(e);
                }
            );
    }

    // Flip the hover pill below the bubble when there isn't room above it inside
    // the scrolling .discBody container (keeps it fully visible on every screen size).
    positionCommentPill(message: any, $event: any): void {
        let bubble = $event.currentTarget as HTMLElement;
        let container = this.$el.find(".discBody")[0] as HTMLElement;
        let spaceAbove =
            bubble.getBoundingClientRect().top -
            (!!container ? container.getBoundingClientRect().top : 0);
        message._pillBelow = spaceAbove < 40; // ~ pill height + caret/gap
    }

    // Confirmed delete (second click on the ecv-confirm-tooltip): soft-delete via
    // DELETE, then show the placeholder in place.
    doDeleteComment(message: any): void {
        message.delFlag = false;
        this.$rootScope.mainShowLoader = "Deleting...";
        this.$_api.deleteDiscussionComment(this.post.id, message.id).then(
            () => {
                message.deleted = true;
                message.editMode = false;
                this.$rootScope.mainShowLoader = false;
                toastr.success("Comment deleted.", "");
            },
            (e) => {
                this.$rootScope.mainShowLoader = false;
                this.$_pop.openInformationModal(e);
            }
        );
    }

    discussionKeypress(keyEvent: any): void {
        //Pressed enter, but not shift+enter
        if (keyEvent.keyCode === 13 && !keyEvent.shiftKey) {
            this.sendComment(keyEvent);
        }
    }

    private setScrollHeight = (): void => {
        // let $discEl: ng.IAugmentedJQuery = this.$el.find('.discBody');
        // this.scrollHeight = $discEl[0].scrollHeight;
        this.scrollHeight = angular.element(".discBody").prop("scrollHeight");
    };

    private scrollDiscussionToPrevious = (): void => {
        if (!!this.scrollHeight) {
            // let $discEl: ng.IAugmentedJQuery = this.$el.find('.discBody');
            // $discEl[0].scrollTop = this.scrollHeight;
            angular.element(".discBody").scrollTop(this.scrollHeight);
        }
    };

    private scrollDiscussionDown = () => {
        let $discEl = this.$el.find(".discBody");
        $discEl[0].scrollTop = $discEl[0].scrollHeight;
    };
    // this function toggles the readOnly state of the input box
    toggleFieldEditMode(state: boolean, field = "title"): void {
        this.updateNotiDot();
        switch (field) {
            case "title": {
                this.originalTitle = this.title;
                this.titleEditMode = state;
                // Update signature badge visibility when title edit mode changes
                this.updateSignatureBadgeVisibility();
                break;
            }
            case "desc": {
                this.originalDesc = this.desc;
                this.descEditMode = state;
                break;
            }
            default: {
            }
        }
        if (state) {
            setTimeout(() => {
                document
                    .getElementById(`post-${field}-text-` + this.post.id)
                    .focus();
            }, 200);
        }
    }

    // this function resets the state of any input box eg. title,desc
    resetFieldText(fieldToReset = "title"): void {
        switch (fieldToReset) {
            case "title": {
                this.title = this.originalTitle;
                this.toggleFieldEditMode(false);
                break;
            }
            case "desc": {
                this.desc = this.originalDesc;
                this.toggleFieldEditMode(false, "desc");
                break;
            }
            default: {
            }
        }
    }
    // Updates the title for the post
    saveFieldText(field = "title"): void {
        let text: string, originalText: string, editMode: boolean;
        switch (field) {
            case "title": {
                text = this.title;
                originalText = this.originalTitle;
                editMode = this.titleEditMode;
                break;
            }
            case "desc": {
                text = this.desc;
                originalText = this.originalDesc;
                editMode = this.descEditMode;
                break;
            }
            default: {
            }
        }
        if (!!editMode) {
            if ((!!text && field == "title") || field == "desc") {
                text = text.replace(/\s\s+/g, " ");
                this.$rootScope.mainShowLoader = "Loading...";
                //if no change in title
                if (text == originalText) {
                    this.$rootScope.mainShowLoader = false;
                    this.toggleFieldEditMode(false, field);
                } else {
                    this.$_api
                        .updateDocumentTitle(
                            this.post.id,
                            this.title,
                            this.desc,
                            this.post.postType
                        )
                        .then(
                            (s) => {
                                this.title = s.title;
                                if (field == "title") {
                                    if (!!this.title) {
                                        this.originalTitle = this.title;
                                    } else {
                                        this.originalTitle = this.title =
                                            "Untitled Note";
                                    }
                                }
                                this.originalDesc = this.desc;
                                this.updateTitleInFeeds(field).then(
                                    (s) => {
                                        this.$rootScope.mainShowLoader = false;
                                        this.toggleFieldEditMode(false, field);
                                        let infoMsg = `${field == "desc"
                                            ? "Description"
                                            : "Title"
                                            } successfully updated.`;
                                        this.isTitleSaving = false;
                                        toastr.success(infoMsg, "");
                                        this.$_docFolder.updateFolderUpdationDate(
                                            this.post.documentFolderId,
                                            new Date(),
                                            FOLDER_MODULES[this.post.postType]
                                        );
                                        if (field == "title") {
                                            this.BroadcastService.broadcast(
                                                "update-doc-title",
                                                [this.originalTitle]
                                            );
                                        }
                                        console.log(
                                            `document ${field} updated=>` +
                                            this.post.id,
                                            this.post.documentFolderId
                                        );
                                    },
                                    (e) => {
                                        this.$_pop.openInformationModal(e);
                                    }
                                );
                            },
                            (e) => {
                                console.log(
                                    `Error while updating Post ${field}` + e
                                );
                                this.$rootScope.mainShowLoader = false;
                            }
                        );
                }
            } else {
                this.$rootScope.mainShowLoader = false;
                this.$_pop.openInformationModal(
                    "Title can not be empty, please enter valid title text."
                );
                return;
            }
        }
    }

    saveFieldTextOnBlur(event, field = "title"): void {
        // Only call save if the blur was not caused by clicking the Save button
        if (!this.isTitleSaving &&
            (!event.relatedTarget || !event.relatedTarget.id.includes(`text-save-btn-${this.post.id}`))) {
            this.saveFieldText(field);
        }
    }
    //Processing key press for title
    postTitleKeypress(keyEvent: any): void {
        //Pressed enter
        if (keyEvent.keyCode === 13) {
            this.isTitleSaving = true;
            if (
                keyEvent.currentTarget.id ==
                "post-title-text-" + this.post.id &&
                !!this.title
            ) {
                this.saveFieldText();
            } else if (
                keyEvent.currentTarget.id == "post-desc-text-" + this.post.id &&
                !!this.desc
            ) {
                this.saveFieldText("desc");
            } else {
                keyEvent.target.blur();
            }
        }
        //Pressed Esc
        if (keyEvent.keyCode === 27) {
            if (
                keyEvent.currentTarget.id ==
                "post-title-text-" + this.post.id
            ) {
                this.resetFieldText();
            } else if (
                keyEvent.currentTarget.id ==
                "post-desc-text-" + this.post.id
            ) {
                this.resetFieldText("desc");
            }
        }
    }

    updateTitleInFeeds(fieldToUpdate = "title"): any {
        let deferred = this.$q.defer();
        let type = "posts";
        let _this = this;
        if (this.postType.base == "discussion") {
            type = "discussions";
        } else if (this.postType.base == "document") {
            type = "documents";
        }
        if (fieldToUpdate == "title") _this.post.title = _this.originalTitle;
        else {
            _this.post.comment = _this.originalDesc;
        }
        let cachedFeeds = _this.$_caching.getCachedFeeds();
        let localFeeds = cachedFeeds[type];
        let localFeed = localFeeds.find((d) => d.id == _this.post.id);
        if (!!localFeed) {
            if (fieldToUpdate == "title") {
                localFeed.title = _this.originalTitle;
            } else {
                localFeed.comment = _this.originalDesc;
            }
        } else {
            localFeeds = localFeeds.concat(this.post);
        }
        type = "posts";
        localFeeds = cachedFeeds[type];
        localFeed = localFeeds.find((d) => d.id == _this.post.id);
        if (!!localFeed) {
            if (fieldToUpdate == "title") {
                localFeed.title = _this.originalTitle;
            } else {
                localFeed.comment = _this.originalDesc;
            }
        }
        this.$_caching.saveCachedFeeds(cachedFeeds);
        this.$_feed.addOrUpdateCachedFolderFeedIds(
            [this.post],
            this.post.documentFolderId,
            true
        );
        deferred.resolve();
        return deferred.promise;
    }

    navigateToOrganize(): void {
        this.$state.go("organize");
    }

    isConvertible = (): boolean => {
        return !!convertibleTypes.find(
            (str) => str == this.getFileExtension(this.post.filename)
        );
    };


    showDownloadSignedLink = () => {
        return (
            this.isPDF() &&
            this.isSharedView != true &&
            (this.post.permissionType == "ACCESS" ||
                this.post.permissionType == "OWN" ||
                (this.post.permissionType == "VIEW" &&
                    !(
                        this.post.signatureAssigned == undefined ||
                        this.post.signatureAssigned == null
                    ))) &&
            this.isLinkActive(
                this.post.signStatus,
                SIGNATURE_FLOW_UNITS
                    .DOWNLOAD_SIGNED_TEMPLATE
            )
        );
    };

    openSharePostModal = (item) => {
        let deferred = this.$q.defer();
        let dispAs =
            this.displayAs == "note"
                ? _.includes(
                    [this.postTypeEnums.DOCUMENT, this.postTypeEnums.LINK],
                    item.postType
                )
                    ? "document"
                    : "discussion"
                : this.displayAs;
        let crntSubj = this.$_cache.getCurrentSubject();
        let msgs = {};
        //execute for documents and videos
        let icon =
            !!item.hasAttachment && item.hasAttachment()
                ? this.$sce.trustAsHtml("<i class='fa fa-file'></i>")
                : this.$sce.trustAsHtml("<i class='fa fa-video-camera'></i>");
        let iconBgColor = "#f4cd02";
        msgs["noSharedUsersMsg"] = Util.NO_SHARED_USERS_DOCUMENT;
        msgs["title"] = Util.SHARE_TITLE;
        msgs["authorInfo"] = Util.AUTHOR_INFO_DOC;
        msgs["chsTmTitle"] = Util.SELECT_TM_TITLE;
        msgs["shrdTitle"] = Util.SHARED_AREA_TITLE;
        //execute for discussion
        if (item.postType == PostTypeEnums.DISCUSSION) {
            icon = this.$sce.trustAsHtml("<i class='fa fa-comments'></i>");
            iconBgColor = "#1bc7a0";
            msgs["noSharedUsersMsg"] = Util.NO_SHARED_USERS_DISCUSSION;
            msgs["title"] = Util.SHARE_TITLE_DISCUSSION;
            msgs["authorInfo"] = Util.AUTHOR_INFO_DISC;
            msgs["chsTmTitle"] = Util.SELECT_TM_TITLE_DISC;
            msgs["shrdTitle"] = Util.SHARED_AREA_TITLE_DISC;
        }
        msgs["shareTooltip"] = this.$sce.trustAsHtml(
            Util.SHARE_WITH_SECURITY_TOOLTIP.replace(/displayAs/g, dispAs)
        );

        if (!item.subjectId && !crntSubj) {
            //If resource folder document is being shared force CR selection
            this.$rootScope.mainShowLoader = false;
            let obj = { item, dispAs, msgs, icon, iconBgColor };
            this.$rootScope.openShare = obj;
            this.$rootScope.forceCRSelection();
            deferred.resolve();
        } else {
            let subjId = item.subjectId;
            !subjId && (subjId = crntSubj.subjectId);
            let eligibleUsers = this.$_team.getUsersEligibleForShare(
                subjId || null,
                item.id || null,
                null,
                item.postType || null
            );
            this.$_pop
                .openSharePopup(
                    item,
                    item.id,
                    eligibleUsers,
                    item.documentUsers,
                    dispAs,
                    false,
                    icon,
                    iconBgColor,
                    true,
                    msgs
                )
                .then(
                    (s) => {
                        if (
                            this.displayAs == "discussion" &&
                            this.expandedCard
                        ) {
                            this.loadMoreComments(null, true);
                        }
                        deferred.resolve(s);
                    },
                    (e) => deferred.reject(e)
                );
        }
        return deferred.promise;
    };

    shareMe = (category, itemId, signedCopy, postType) => {
        this.$uibModal
            .open({
                templateUrl:
                    "app/common/popup/shareableLink/shareableLink.html",
                controller: "ShareableLinkController",
                controllerAs: "shareableLinkVm",
                resolve: {
                    category: () => category,
                    itemId: () => itemId,
                    signCopyExists: () => signedCopy,
                    postType: () => postType,
                },
            })
            .result.then(
                function (s) {
                    console.log("Closed!");
                },
                function (e) {
                    console.log("Dismissed!");
                }
            );
    };

    deleteMe = (item) => {
        let sent1 =
            "Are you sure you want to delete this " +
            this.UtilityService.toTitleCase(item.postType) +
            "?";
        this.$rootScope.mainShowLoader = "Deleting ..";
        this.$_api.deleteDocument(item.id, item.postType).then((s) => {
            this.$_feed.deleteFeed(item.id).then((s) => {
                //delete the notification related to this document/discussion
                this.$_pushNotificationService.deleteDocumentNotification(
                    item.id
                );

                this.$rootScope.mainShowLoader = false;
                let infoMsg =
                    "You have successfully deleted this " +
                    this.UtilityService.toTitleCase(item.postType) +
                    ".";
                toastr.success(infoMsg, "");
                this.postCallback(
                    this,
                    MENU_ACTIONS.DELETE.toUpperCase(),
                    item.id
                );
            });
        });
    };

    regenerateSummary = (event, documentId) => {
        this.doNothing(event);
        this.$_api.regenerateAISummary(documentId).then(
            (s) => {
                toastr.success("Summary is currently being generated.", "", {
                    timeOut: 2000,
                });
            },
            (e) => {
                if (!!e) {
                    toastr.error(e);
                } else {
                    toastr.error(
                        "Something went wrong. Please try after some time."
                    );
                }
            }
        );
    };

    documentOperation = ($event, operation, document) => {
        let route = "view-document";
        !!$event && $event.stopPropagation();
        if ($event.type != "dblclick") {
            this.updateNotiDot();
        }
        if (this.$state.current.name == "list-rl") {
            route = "view-rl-document";
        }
        switch (operation) {
            case MENU_ACTIONS.OPEN:
                if (
                    $event.target.className.includes("stop-click") != true ||
                    $event.target.className.includes("action-open") == true
                ) {
                    if (document.postType == "DOCUMENT") {
                        if (!!this.multiSelectMode) {
                            this.toggleDocSelection();
                        } else {
                            const params = {
                                documentId: document.id,
                                folderId: document.documentFolderId
                            };
                            // This is done to avoid reloading the RL so that the chatbot's chat history is not cleared.
                            if (route === "view-rl-document" && this.$ocLazyLoad.isLoaded("eCareVault.documents")) {
                                this.$state.go("view-rl-document", params);
                            } else {
                                this.$state.go("documents-load", {
                                    action: route,
                                    stateParams: params
                                });
                            }
                        }
                    } else if (document.postType == PostTypeEnums.LINK) {
                        if (!!this.multiSelectMode) {
                            this.toggleDocSelection();
                        } else {
                            const params = {
                                documentId: document.id,
                                folderId: document.documentFolderId,
                                postType: document.postType,
                            };
                            // This is done to avoid reloading the RL so that the chatbot's chat history is not cleared.
                            if (route === "view-rl-document" && this.$ocLazyLoad.isLoaded("eCareVault.documents")) {
                                this.$state.go("view-rl-document", params);
                            } else {
                                this.$state.go("documents-load", {
                                    action: route,
                                    stateParams: params
                                });
                            }
                        }
                    } else {
                        this.$state.go("discussions-load", {
                            action: "discussion-board-discuss",
                            stateParams: {
                                discussion: document.id,
                                folderId: document.documentFolderId
                            }
                        });
                    }
                }
                break;
            case MENU_ACTIONS.SHARE:
                this.$rootScope.mainShowLoader = true;
                this.openSharePostModal(document).then(() => {
                    if (document.postType == "DOCUMENT") {
                        this.$_docFolder.updateFolderUpdationDate(
                            document.documentFolderId,
                            new Date(),
                            FOLDER_MODULES[this.post.postType]
                        );
                    }
                });
                break;
            case MENU_ACTIONS.VIEW_FORM:
                this.$state.go("forms-load", {
                    action: 'view',
                    formId: 0,
                    asgnId: this.post.assignedFormId,
                    ref: "cmpf",
                });
                break;
            case MENU_ACTIONS.VIEW:
                if (this.post.postType == PostTypeEnums.LINK) {
                    this.viewLink();
                } else {
                    this.viewDocument($event);
                }
                break;
            case MENU_ACTIONS.DOWNLOAD:
                this.downloadDocument($event, "ACCESS", false);
                break;
            case MENU_ACTIONS.SHAREABLE_LINK:
                this.shareMe(
                    "Document",
                    document.id,
                    this.showDownloadSignedLink(),
                    document.postType
                );
                break;
            case MENU_ACTIONS.SIGNATURE:
                break;
            case MENU_ACTIONS.RENAME:
                this.toggleFieldEditMode(true);
                break;
            case MENU_ACTIONS.EDIT_DESCRIPTION:
                this.toggleFieldEditMode(true, "desc");
                break;
            case MENU_ACTIONS.MOVE:
            case MENU_ACTIONS.COPY:
                this.$_docFolder.folderOperation($event, operation, document);
                break;
            case MENU_ACTIONS.DELETE:
                this.deleteMe(document);
                break;
            case MENU_ACTIONS.SET_UP_SIGN:
                this.showSignaturePopUp(
                    $event,
                    SIGNATURE_FLOW.SETUP
                );
                break;
            case MENU_ACTIONS.APPLY_TEMPLATE:
                this.showSignaturePopUp(
                    $event,
                    SIGNATURE_FLOW.APPLY_TEMPLATE
                );
                break;
            case MENU_ACTIONS.REVIEW_SIGN:
                this.showSignaturePopUp(
                    $event,
                    SIGNATURE_FLOW.REVIEW
                );
                break;
            case MENU_ACTIONS.SIGN_DOC:
                this.showActualSigningPopup($event);
                break;
            case MENU_ACTIONS.DOWNLOAD_SIGN:
                this.downloadDocument($event, "ACCESS", true);
                break;
            case MENU_ACTIONS.REGENERATE_SUMMARY:
                this.regenerateSummary($event, document.id);
                break;
            default:
                console.error(
                    "EcvContextMenu_DOC: Operation '",
                    operation,
                    "not currently supported"
                );
                break;
        }

        if (operation != MENU_ACTIONS.SIGNATURE) {
            let id = "#document-options-" + document.id;
            (
                $($(id).find("#folder-options-popover")[0]) as MenuPopover
            ).popover("hide");
        }
        return true;
    };

    toggleDocSelection = (event?) => {
        !!event && event.stopPropagation();
        if (this.isLink) {
            toastr.success("Link cannot be downloaded");
            return;
        }
        if (this.post.permissionType == "VIEW") {
            toastr.success(
                "You have View Only access to this Document and cannot download it"
            );
            return;
        }
        this.post.isSelected = !this.post.isSelected;
        let thisPostId = this.post.id;
        if (!!this.post.isSelected) {
            this.selectedDocs.push(this.getDocDownloadObj());
        } else {
            let ind = this.selectedDocs.findIndex((p) => p.id == thisPostId);
            if (ind != -1) {
                this.selectedDocs.splice(ind, 1);
            }
        }
    };

    getDocDownloadObj = (downloadSignedCopy?) => {
        let signedCopy = _.isNil(downloadSignedCopy)
            ? this.showDownloadSignedLink()
            : downloadSignedCopy;
        return {
            id: this.post.id,
            filename:
                this.post.title +
                (signedCopy ? "-signed" : "") +
                "." +
                this.getFileExtension(this.post.filename),
            keywords: this.post.keywords,
            signedCopy: signedCopy,
            rawDocSize: this.post.rawDocSize,
        };
    };

    // This function is called on click of view AI summary link. It calls API to fetch the summary
    // and displays the summary.
    viewGeneratedSummary = (event) => {
        this.updateNotiDot();
        this.doNothing(event);
        this.$rootScope.mainShowLoader = true;
        this.$_api.fetchAISummary(this.post.id).then(
            (s) => {
                this.originalSummary = s.summary;
                this.$rootScope.mainShowLoader = false;
                // automatically set focus to the generated summary box
                setTimeout(function () {
                    document
                        .getElementById("original-summary")
                        .scrollIntoView();
                }, 200);
            },
            (e) => {
                this.$rootScope.mainShowLoader = false;
                if (!!e) {
                    toastr.error(e);
                } else {
                    toastr.error(
                        "Something went wrong. Please try after some time."
                    );
                }
            }
        );
    };

    copySuccessCallback = () => {
        this.copyTooltip = "Successfully copied to clipboard";
        this.$timeout(() => {
            this.copyTooltip = angular.copy(this.copyTooltipText);
        }, 5000);
    };

    replaceSummary() {
        this.replaceTooltipText = "";
        if (this.regeneratedSummary) {
            this.$_api.confirmRegenerateAISummary(
                this.regeneratedSummaryId,
                this.post.id,
                "SUCCESS"
            );
            this.originalSummary = this.regeneratedSummary;
            this.regeneratedSummary = "";
            this.isRegeneratedSummaryAvailable = false;
        } else {
            console.error("Regenerated summary not found!");
        }
    }

    cancelSummary() {
        this.isRegeneratedSummaryAvailable = false;
        this.$_api.confirmRegenerateAISummary(
            this.regeneratedSummaryId,
            this.post.id,
            "DENIED"
        );
    }

    showModal(event){
        this.$_pop.openDiscussionPopupOnLinkClick(event);
    }

    /**
     * Load signature status for the document
     * This method fetches signature metadata and displays it in the UI
     */
    loadSignatureStatus(): void {
        // Only load signature status for documents in expanded view.
        if (!this.post ||
            this.post.postType !== PostTypeEnums.DOCUMENT ||
            !this.expandedCard) {
            return;
        }

        this.$rootScope.mainShowLoader = true;

        this.$_api.getDocumentSignatureStatus(this.post.id)
            .then((response) => {
                this.signatureStatus =
                    response &&
                    Array.isArray(response.signers) &&
                    response.signers.length > 0
                        ? response
                        : null;

                // Only initialize ng-table when signer data exists.
                if (this.signatureStatus) {
                    this.initSignatureTable();
                } else {
                    this.signatureTableParams = null;
                }
            })
            .catch(() => {
                console.log('Signature status not available for this document');
                this.signatureStatus = null;
                this.signatureTableParams = null;
            })
            .finally(() => {
               this.$rootScope.mainShowLoader = false;
            });
    }

    /**
     * Initialize signature table with NgTableParams
     * This creates a sortable table for displaying signature status
     */
    initSignatureTable(): void {
        this.signatureTableParams = new this.NgTableParams({
            count: this.signatureStatus.signers.length,
            sorting: { signerName: 'asc' }
        }, {
            counts: [],
            dataset: this.signatureStatus.signers
        });
    }

}

function post(): ng.IDirective {
    return {
        restrict: "E",
        scope: {
            commentCallback: "=ecvCommentCallback",
            postCallback: "=ecvPostCallback",
            showComments: "=?ecvShowComments",
            displayAs: "=ecvDisplayPostAs",
            expandOnClick: "=ecvExpandOnClick",
            post: "=ecvPostObject",
            defaultExpanded: "=ecvDefaultExpanded",
            showShareControls: "@?ecvShowShareControls",
            enableCrProfile: "@?ecvEnableCrProfile",
            postActionReload: "=ecvPostActionReload",
            subject: "=?ecvSubject",
            isSharedView: "=?ecvSharedView",
            forceHideView: "@?forceHideView",
            signAssignor: "=",
            listView: "=",
            multiSelectMode: "=",
            selectedDocs: "=",
            cmenuPlacement: "=?",
            cmenuSelector: "=?",
        },
        bindToController: true,
        templateUrl: "app/common/itemCard/components/post/post.directive.html",
        replace: true,
        controller: EcvPost,
        controllerAs: "postVm",
        link: (
            scope: ng.IScope,
            element: ng.IAugmentedJQuery,
            attributes: ng.IAttributes,
            controller: IEcvPost
        ): void => {
            controller.init(element);
            scope.$watch(
                () => {
                    return !!controller.post ? controller.post.id : null;
                },
                (newVal, oldVal) => {
                    if (newVal != oldVal) {
                        controller.init(element);
                    }
                }
            );
            scope.$watch(
                () => {
                    return !!controller.post ? controller.post.title : null;
                },
                (newVal, oldVal) => {
                    if (newVal != oldVal) {
                        controller.init(element);
                    }
                }
            );
        },
    };
}

angular.module("eCareVault.common.itemCard").directive("ecvPost", post);
